import { useMemo } from "react";
import { ComponentValueCheckerProps } from "./ComponentValueCheckerProps";
import { Empty } from 'antd';
import { CloseCircleFilled } from "@ant-design/icons";
import styles from './ComponentValueChecker.module.scss';

const SmallError = ({ title = "Couldn't load data" }) => (
    <div style={{ textAlign: "center" }}>
        <CloseCircleFilled
            className={styles.icon}
        />
        <div className={styles.title}>
            {title}
        </div>
    </div>
);

const ComponentValueChecker = (props: ComponentValueCheckerProps): JSX.Element => {
    const { children, value, isError } = props;

    const valueCheck = useMemo(() => {
        if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
            return undefined;
        }
        return value;
    }, [value])

    if (isError) {
        return (
            <SmallError />
        );
    }
    if (valueCheck === undefined) {
        return (
            <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Data"
            />
        );
    }

    return (
        <>{children}</>
    );
}

export default ComponentValueChecker;